import { Record } from 'immutable';
import { Base } from './base';
import { first, isArray, keyBy } from 'lodash';
import { uploadImagesToCloudinary } from '../actions/cloudinary';
import { customerResourceLoading } from '../actions/customer';
import Contact from './contact';
import Image from './image';
import Hour from './hour';
import moment from 'moment';

class Place extends Base(Record({
    id: null,
    hidden: false,
    line1: '',
    line2: '',
    locality: '',
    name: '',
    postal_code: '',
    region: '',
    latitude: 0,
    longitude: 0,
    vendor_id: null,
    proxies: [Contact, Hour, Image]
  })) {
    $create(id) {
      return this.api.post({
        resource: 'places'
      }, this.api.payload('places', id ? this.set('vendor_id', id) : this));
    }

    $get(id) {
      if (this.vendor_id) id = this.vendor_id;

      return this.api.get({
        resource: 'places?filter[vendor_id]=' + id + '&filter[hidden]=false'
      })
      .then(res => Promise.all(
        [res].concat(res.data.map(v => Promise.all(
          this.proxies.map(p => this.$proxy(new p({ owner_id: v.id }), v.id))
        )))
      ))
      .then(res => this.dispatch(this.actions.receiveEntities(first(res).data, 'places')));
    }

    $put() {
      if (this.state.entities.get('places').get(this.id).equals(this)) {
        return Promise.resolve({ data: this });
      }

      return this.api.put({
        id: this.id,
        resource: 'places'
      }, this.api.payload('places', this))
      .then(res => this.dispatch(this.actions.receiveEntity(res.data)));
    }

    contacts(type) {
      let contacts = this.state.entities.get('contacts')
        .filter(c => c.owner_id === this.id && c.owner_type === 'places')

      if (type) contacts = contacts.filter(c => c.type === type);

      return contacts;
    }

    setProfileImage = (image) => {
      const profileImage = this.getProfileImage();

      this.dispatch(customerResourceLoading('profilePic', true));
      this.dispatch(uploadImagesToCloudinary(image))
        .then(images => Promise.all([
          profileImage && profileImage.$delete(),
          Promise.all(images.map(i => new Image({ 
            url: i, 
            owner_type: 'places', 
            label: 'profile' 
          }).$create(this.id)))
        ]))
        .then(res => this.dispatch(customerResourceLoading('profilePic', false)));
    }

    deleteProfileImage = () => {
      return Promise.all(this.getProfileImage().map(i => i.$delete()))
        .then(this.dispatch(this.actions.clearEntities('images')));
    }

    hours() {
      return this.state.entities.get('hours')
        .filter(h => h.place_id === this.id);
    }

    getProfileImage() {
      return this.state.entities.get('images')
        .filter(i => i.owner_id === this.id && i.owner_type === 'places' && i.label === 'profile').last();
    }

    formatHoursForPlan() {
      let days = keyBy(this.hours().toJS(), h => h.day.toLowerCase());

      this.hours().map(h => {
        if (!isArray(days[h.day.toLowerCase()])) days[h.day.toLowerCase()] = [];

        days[h.day.toLowerCase()].unshift(h);
        return h;
      });

      return days;
    }

    isOpenToday() {
      const today = moment().format('YYYY-MM-DD');
      const todayHours = this.hours().filter(h => h.day === moment().format('dddd'));
      const open = todayHours.filter(h => moment().isBetween(moment(today + ' ' + h.open), moment(today + ' ' + h.close)));
      return open.size > 0;
    }

    todayCloseTime() {
      const todaysHours = this.hours().filter(h => h.day === moment().format('dddd'));

      if (todaysHours.size > 1) return todaysHours.first().close;
      return todaysHours.last().close;
    }
  }

export default Place;



// WEBPACK FOOTER //
// ./src/records/place.js